export default __webpack_public_path__ + "static/media/ruc.7ba3885a.pdf";